<template>
  <div
    v-if="filter !== null"
    class="d-flex flex-row flex-wrap flex-gap-8"
  >
    <v-autocomplete
      v-show="hardcodedAttribute === null"
      outlined
      dense
      hide-details
      :label="$t(langPath + 'chooseAttr')"
      :value="attr"
      :items="items"
      @input="propertyChanged"
    />
    <slot name="operator" />
    <v-autocomplete
      v-if="Array.isArray(possibleValues[attr].values)"
      v-model="
        /* eslint-disable-next-line vue/no-mutating-props */
        filter[operator][attr]
      "
      outlined
      dense
      hide-details
      :items="possibleValues[attr].values || []"
    />
    <span
      v-else-if="possibleValues[attr].type === APIFilterDataType.DATE"
      class="d-flex flex-nowrap"
    >
      <FormDateTimePicker
        v-model="
          /* eslint-disable-next-line vue/no-mutating-props */
          filter[operator][attr]
        "
        single
      />
    </span>
    <v-text-field
      v-else
      v-model="
        /* eslint-disable-next-line vue/no-mutating-props */
        filter[operator][attr]
      "
      outlined
      dense
      :label="$t('base.filterConfig.fill')"
      hide-details
      :rules="[formRules.required]"
      :type="possibleValues[attr].type"
    />
  </div>
</template>

<script>
    import formRules from "@/utils/formRules";
    import {APIFilterMixin} from "@/app/mixins/APIFilterMixin";
    import {APIFilterDataType} from "@/service/APIFilters";
    import FormDateTimePicker from "@/app/components/form/FormDateTimePicker.component";

    export default {
        name: "FilterConfigBinaryOp",
        components: {FormDateTimePicker},
        mixins: [APIFilterMixin],
        data: () => ({
            formRules: formRules,
            APIFilterDataType: APIFilterDataType
        }),
        computed: {
            attr: function () {
                return Object.keys(this.filter[this.operator])[0];
            }
        },
        methods: {
            propertyChanged: function (newValue) {
                const oldValue = this.attr;
                delete this.filter[this.operator][oldValue];
                const possiblePropertyValues = this.possibleValues[newValue].values;
                this.$set(this.filter[this.operator], newValue, Array.isArray(possiblePropertyValues) ? possiblePropertyValues[0].value : undefined);
            }
        }
    };
</script>

<style scoped>

</style>
